import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeCourseLocaleModule: LocaleModule = {
  name: "employeeCourse",
  messages: { en: en, it: it },
};
